import React from "react";
const SpamhausEDROPAdapterSummary = () => /* @__PURE__ */ React.createElement("dl", null, /* @__PURE__ */ React.createElement("i", null, "No configuration required."));
export default SpamhausEDROPAdapterSummary;
